// extracted by mini-css-extract-plugin
export default {"root":"ozRLN","left":"_3FBgF","right":"_31LfD","author":"_3BxsW","actions":"_31KrU"};